import moment from 'moment'
import React, { PureComponent, ReactNode } from 'react'
import { Button, Modal } from '../../../components'
import { IActivePass } from '../../../models'
import { LiteralsService } from '../../../services'
import StyledDiv from './styles'

interface IProps {
  passes: IActivePass[]
  // travellers on this booking: a limited pass needs one usage left per seat
  seats: number
  isConfirming: boolean
  onConfirm: (activePassId: number) => void
  onClose: () => void
}

interface IState {
  selectedPassId?: number
}

export class SelectActivePassModal extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    // Preselect the first pass that can actually cover the booking.
    this.state = { selectedPassId: props.passes.find(pass => !this.isDisabled(pass))?.id }
  }

  public render(): ReactNode {
    const { passes, isConfirming, onClose } = this.props
    const { selectedPassId } = this.state
    const selectedPass = passes.find(pass => pass.id === selectedPassId)

    return (
      <Modal isHidden={ false } onOverlayClick={ onClose }>
        <StyledDiv>
          <span className="title">{ LiteralsService.get('selectActivePass', true) }</span>
          {
            passes.length
              ? <div className="passes">{ passes.map(pass => this.passOption(pass)) }</div>
              : <div className="empty">{ LiteralsService.get('noActivePasses', true) }</div>
          }
          <footer>
            <Button
              title={ LiteralsService.get('confirm') }
              styles={{ width: '100%' }}
              onPress={ () => this.props.onConfirm(selectedPassId!) }
              isDisabled={ !selectedPass || this.isDisabled(selectedPass) || isConfirming }
              filled
              upper
            />
            <Button
              title={ LiteralsService.get('cancel') }
              styles={{ width: '100%' }}
              onPress={ onClose }
              isDisabled={ isConfirming }
              upper
            />
          </footer>
        </StyledDiv>
      </Modal>
    )
  }

  private passOption(pass: IActivePass): ReactNode {
    const isDisabled = this.isDisabled(pass)
    const isSelected = this.state.selectedPassId === pass.id
    const endDate = moment.utc(pass.endDateTime).local()

    return (
      <div
        key={ pass.id }
        className={ `pass ${ isSelected ? 'selected' : '' } ${ isDisabled ? 'disabled' : '' }` }
        onClick={ () => !isDisabled && this.setState({ selectedPassId: pass.id }) }
      >
        <span className="name">{ pass.temporalPass.name }</span>
        <span className="info">{ `${ LiteralsService.get('validUntil', true) }: ${ endDate.format('L') }` }</span>
        <span className={ isDisabled ? 'error' : 'info' }>
          { `${ LiteralsService.get('usages', true) }: ${ this.usagesLabel(pass) }` }
        </span>
        { isDisabled && <span className="error">{ LiteralsService.get('notEnoughUsages', true) }</span> }
      </div>
    )
  }

  private usagesLabel(pass: IActivePass): string {
    return pass.temporalPass.usageLimit
      ? `${ pass.usages } / ${ pass.temporalPass.usageLimit }`
      : LiteralsService.get('unlimited', true)
  }

  private isDisabled = (pass: IActivePass): boolean => {
    return !!pass.temporalPass.usageLimit && pass.usages < this.props.seats
  }
}
